import { Card, Col,  Row } from 'react-bootstrap';
import CommentPieCard from './CommentPieCard';
import { COLOR, STYLE } from '../../../config/constraits';
import { SurveysFeelings } from '../types';
import { useTranslation } from "react-i18next";
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import ChartShareActions from '../../../components/ChartShareActions';

interface CommentsDetailProps {
  feelings: SurveysFeelings
}

export default function CommentsDetail({ feelings }: CommentsDetailProps) {

  const { t } = useTranslation('dashboard');

  const PIE_COMMENTS = [
    {
      commentType: "positive",
          label: t("dashboard:feelingAnalysis.commentsDetailCommentsPositive"),
      percentage: feelings.positivePercentage,
      comments: feelings.totalPositive,
      totalComments: feelings.totalSurveys,
      color: COLOR.VERD,
    },
    {
      commentType: "neutral",
        label: t("dashboard:feelingAnalysis.commentsDetailCommentsNeutral"),
      percentage: feelings.neutralPercentage,
      comments: feelings.totalNeutral,
      totalComments: feelings.totalSurveys,
      color: COLOR.TARONJA,
    },
    {
      commentType: "negative",
        label: t("dashboard:feelingAnalysis.commentsDetailCommentsNegative"),
      percentage: feelings.negativePercentage,
      comments: feelings.totalNegative,
      totalComments: feelings.totalSurveys,
      color: COLOR.VERMELL,
    }
  ]

    const feelingchartRef = useRef<HTMLDivElement>(null);

    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

    return (
        <div ref={feelingchartRef}> 

    <Card
      style={{
        backgroundColor: "white",
                borderRadius: STYLE.BORDER_RADIUS,
                position: "relative"
      }}
                className="p-2 d-flex justify-content-center align-items-center text-center"
            >
                <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                    <ChartShareActions
                        chartRef={feelingchartRef}
                        title={t("dashboard:feelingAnalysis.commentsDetailsHeader")}
                        filters={selectedFilters}
                        t={t}
                    />
                </div>

                <Row className="w-70 d-flex justify-content-center align-items-center mt-2">
                    <h4 className="pt-2">{t("dashboard:feelingAnalysis.commentsDetailsHeader")}</h4>

        {PIE_COMMENTS.map((value, index) => (
          <Col key={index} xs="auto">
            <Card className="p-3" style={{ backgroundColor: "#F5F5F5", border: "none", borderRadius: STYLE.BORDER_RADIUS }}>
            <CommentPieCard
              commentType={value.commentType}
              label={value.label}
              percentage={value.percentage}
              comments={value.comments}
              totalComments={value.totalComments}
              color={value.color}
            />
            </Card>
          </Col>
        ))}
      </Row>
            </Card>
    </div>
  );
}
